import { render } from "./voucher-reward.html?vue&type=template&id=7ca0c515&ts=true"
import script from "./voucher-reward.vue?vue&type=script&lang=ts"
export * from "./voucher-reward.vue?vue&type=script&lang=ts"

import "./voucher-reward.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__